import { createModel } from '@features/hox';
import {
  ContentsType,
  RoleType,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { useContents } from '@/pages/Homepage/hooks';

export const useCourseModel = createModel(() => {
  const { state: initState, actions: initActions } = useContents();

  const state = {
    ...initState,
  };

  const actions = {
    ...initActions,
    init: async (role: RoleType) => {
      return initActions.init(
        {
          category: ContentsType.Courses,
          role_type: role,
          only_directory: true,
          list_contents_number: 3,
          list_contents_limit: 8,
        },
        1,
      );
    },
    loadPage: async (contentId: number, curPage: number) => {
      return initActions.loadPage({
        content_id: contentId,
        page: curPage,
        limit: 8,
      });
    },
  };

  return {
    ...state,
    ...actions,
  };
});
